import React from 'react';
import { Ga4StandAlone } from './Ga4StandAlone';
import { useCampaignId } from 'hooks';

export const Ga4Page = () => {
  const campaignId = useCampaignId();

  return campaignId ? <Ga4StandAlone /> : <>No campaign Id</>;
};
